import { Autocomplete, Checkbox, FormControlLabel, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import PermissionsStyles from '../../../../components/Permissions/styles/PermissionsStyles';

// "All branches" (the default, stored as an empty list) or specific branches.
const BranchesPicker = ({ options, allSelected, onAllSelectedChange, value, onChange }) => {
  const labelOf = (code) => options.find((b) => b.code === code)?.label || code;
  return (
    <>
      <Typography variant="subtitle2" color="#0054A5">
        סניפים
      </Typography>
      <RadioGroup row value={allSelected ? 'all' : 'some'} onChange={(e) => onAllSelectedChange(e.target.value === 'all')}>
        <FormControlLabel value="all" control={<Radio size="small" />} label="כל הסניפים" />
        <FormControlLabel value="some" control={<Radio size="small" />} label="סניפים מסוימים" />
      </RadioGroup>
      {!allSelected && (
        <Autocomplete
          multiple
          disableCloseOnSelect
          options={options.map((b) => b.code)}
          value={value}
          onChange={(_, selected) => onChange(selected)}
          getOptionLabel={labelOf}
          renderOption={(props, code, { selected }) => (
            <li {...props} key={code}>
              <Checkbox size="small" checked={selected} sx={PermissionsStyles.checkbox} />
              {labelOf(code)}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="בחר סניף אחד או יותר"
              error={value.length === 0}
              helperText={value.length === 0 ? 'יש לבחור לפחות סניף אחד' : ''}
              sx={PermissionsStyles.textField}
            />
          )}
        />
      )}
    </>
  );
};

export default BranchesPicker;
